module.exports = __webpack_public_path__ + "media/images/matrix_preview_portrait-005467d5c2fa2dc0b15a61f2db0a2e2b.png";